import React, { useState } from "react";
import DialogComponent from "../components/DialogComponent";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import axios from "axios";

function Play({ setDailog, roomId }) {
  const [InviteNumber] = useState(roomId);
  const [flowUrl, setflowUrl] = useState("");
  const [, setData] = useState("No Data");
  const updatedUrl = localStorage.getItem("apiEndpoint");
  const baseURL = updatedUrl?.length
    ? updatedUrl
    : window.config.apiEndpoint;

  const handlePhoneNoChange = (e) => {
    setflowUrl(e.target.value);
  };

  function ClearResponse() {
    setData("");
  }

  function InviteAPI(event) {
    ClearResponse();
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    const roomId = InviteNumber;
    const requestBody = {
      FlowData: `<?xml version="1.0" encoding="UTF-8"?>
<Response><Play>${flowUrl}</Play></Response>`,
    };
    axios
      .post(`${baseURL}/accounts/${acId}/room/${roomId}/play`, requestBody, {
        headers: headers,
      })
      .then(function (response) {
        console.log(response);
        toast.success("Api call success");
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
    setDailog(false);
  }

  return (
    <>
      <DialogComponent
        heading="Play"
        ButtonName="Play"
        handleClick={InviteAPI}
        // handleChange={handleInviteChange}
        handleChange1={handlePhoneNoChange}
        PlaceholderName2="Play Url"
        data={InviteNumber}
        data1={flowUrl}
        PlaceholderName="Room ID"
        setDailog={setDailog}
      />
    </>
  );
}
Play.propTypes = {
  setDailog: PropTypes.any,
  roomId: PropTypes.any,
};
export default Play;
